import React, {Component} from 'react';
import PropTypes from 'prop-types';

/** The Search component lets you type in and submit
    a subreddit name to adjust the viewers content.* */
class Search extends Component {
  /** @inheritdoc */
  constructor(props) {
    super(props);

    this.state = {term: ''};

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**
   * Adjusts the state to the term that was put in the input field.
   * @param {object} event - The event object containing the change.
   * @returns {undefined}
   */
  handleChange(event) {
    this.setState({term: event.target.value.replace(/ /g, '')});
  }

  /**
   * Changes the route when the user submits the search form.
   * @param {object} event - The event object containing the submit.
   * @returns {undefined}
   */
  handleSubmit(event) {
    event.preventDefault();
    /* Here we determine if the user is browsing this within the
    	viewer or on the homepage. */
    const location = this.props.location;

    if (this.props.params.filter && !location.query.sort && !location.query.t) {
      this.context.router.push(
        `/r/${this.state.term}/${this.props.params.filter}`
      );
    } else if (location.query.sort && location.query.t) {
      this.context.router.push(
        `/r/${this.state.term}/${this.props.params.filter}/?sort=${
          location.query.sort
        }&t=${location.query.t}`
      );
    } else {
      this.context.router.push(`/r/${this.state.term}/hot`);
    }

    return this.setState({term: ''});
  }

  /**
   * Renders the Search component.
   * @returns {string} JSX representation of the component.
   */
  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="input-field col s6">
          <input
            value={this.state.term}
            onChange={this.handleChange}
            id="term_search"
            type="text"
            className="validate"
          />
          {this.props.params.sub && (
            <label className="active" htmlFor="term_search">
              Currently viewing /r/{this.props.params.sub}
            </label>
          )}
          {!this.props.params.sub && (
            <label className="active" htmlFor="term_search">
              Enter a Subreddit Name...
            </label>
          )}
        </div>
      </form>
    );
  }
}

Search.contextTypes = {
  router: PropTypes.object,
};

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js